import { render, staticRenderFns } from "./AIInterpret.vue?vue&type=template&id=f3263326&scoped=true"
import script from "./AIInterpret.vue?vue&type=script&lang=js"
export * from "./AIInterpret.vue?vue&type=script&lang=js"
import style0 from "./AIInterpret.vue?vue&type=style&index=0&id=f3263326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3263326",
  null
  
)

export default component.exports